import { FetchArgs, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import moment from 'moment';
import baseURL from 'src/api/BaseUrl';
import baseURLTsda from 'src/api/BaseUrlTsda';
import { UI_TIME_ZONE } from 'src/constants/formats';
import { REACT_APP_API_TSDA, archLevel } from 'src/data/config';
// import { archLevel } from 'src/data/config';
import { RootState } from 'src/store/index';

/**Uncomment below code fro retry implementation */
export const baseQuery = retry(
  async (args: string | FetchArgs, api, extraOptions) => {
    const result = await fetchBaseQuery({
      baseUrl: baseURL,
      prepareHeaders: (headers, { getState }) => {
        const token = ((getState() as RootState)?.user?.user as any)?.sponsorToken;
        const sponsor = ((getState() as RootState)?.user?.user as any)?.sponsor_sponsor_name;
        if (token) {
          headers.set('authorization', `Bearer ${token}`);
        }
        if (sponsor) {
          headers.set('sponsor', sponsor);
        }
        headers.set('site_token', `${(getState() as RootState).user?.user?.siteToken}`);
        headers.set('user_date_time', moment().format());
        return headers;
      }
    })(args, api, extraOptions);

    if (
      result?.error &&
      !(
        result.error?.status === 500 ||
        result.error?.status === 502 ||
        result.error?.status === 503 ||
        result.error?.status === 504
      )
    ) {
      retry.fail(result.error);
    }
    return result;
  },
  {
    maxRetries: 0
  }
);

export const tsdaBaseQuery = retry(
  async (args: string | FetchArgs, api, extraOptions) => {
    const baseUrldata: any = (api?.getState() as RootState)?.site?.siteInfo?.site?.hospital_slug_url;
    const baseUrl = `${archLevel == 'site' ? baseURLTsda : `${REACT_APP_API_TSDA}${baseUrldata}/tsda`}`;
    const result = await fetchBaseQuery({
      baseUrl,
      prepareHeaders: (headers, { getState }) => {
        const token = ((getState() as RootState)?.user?.user as any)?.siteToken;
        const sponsor = ((getState() as RootState)?.user?.user as any)?.sponsor_sponsor_name;
        if (token) {
          headers.set('authorization', `Bearer ${token}`);
        }
        if (sponsor) {
          headers.set('sponsor', sponsor);
        }
        headers.set('sponsor_token', `${(getState() as RootState).user?.user?.sponsorToken}`);
        headers.set('time_zone_id', UI_TIME_ZONE);
        headers.set('user_date_time', moment().format());

        return headers;
      }
    })(args, api, extraOptions);

    if (
      result?.error &&
      !(
        result.error?.status === 500 ||
        result.error?.status === 502 ||
        result.error?.status === 503 ||
        result.error?.status === 504
      )
    ) {
      retry.fail(result.error);
    }
    return result;
  },
  {
    maxRetries: 0
  }
);
